import {useBootstrapDataStore} from '@ui/bootstrap-data/bootstrap-data-store';
import {useMemo} from 'react';

interface Data {
  icon?: string;
  id: number;
  name: string;
  domain?: string;
}

export interface UseFiltersReturn {
  qualities: Data[];
  languages: Data[];
  subs: Data[];
  hosts?: Data[];
  categories: Data[];
  types: Data[];
}

export function useLinkFiltersData(): UseFiltersReturn {
  const data = useBootstrapDataStore(s => s.data);
  return useMemo(() => {
    return {
      qualities: data?.qualities,
      languages: data?.languages,
      subs: data?.subs,
      hosts: data?.hosts,
      categories: data?.categories,
      types: data?.types,
    };
  }, [data]);
}
